export default "__VITE_ASSET__Cw33yM_l__"